import axios from 'axios'
import qs from 'query-string'
// import K from '../constants'

function buildCfg (cfg) {
  const out = {
    headers: {
       Authorization: `Bearer ${localStorage.getItem('jwt')}`,
    },
  }

  if (cfg) {
    for (const key in cfg) {
      if (key === 'headers') {
        Object.assign(out[key], cfg[key])
      } else {
        out[key] = cfg[key]
      }
    }
  }

  return out
}

function getApiUrl (url) {
  return '/nubium' + url
}

function imaginary (url, opts) {
  const q = {
    url: url,
    ...opts,
  }

  // console.log(`https://imaginary.service.codeisalie.fr/resize?${qs.stringify(q)}`)

  return `https://imaginary.service.codeisalie.fr/resize?${qs.stringify(q)}`
}

const http = {
  core: axios,
  getApiUrl,
  imaginary,
  api: {
    get (url, cfg) {
      const u = getApiUrl(url)
      return axios.get(u, buildCfg(cfg))
    },
    delete (url, cfg) {
      const u = getApiUrl(url)
      return axios.delete(u, buildCfg(cfg))
    },
    put (url, data, cfg) {
      const u = getApiUrl(url)
      return axios.put(u, data, buildCfg(cfg))
    },
    post (url, data, cfg) {
      const u = getApiUrl(url)
      return axios.post(u, data, buildCfg(cfg))
    },
  },
}

export default http
